// CSV construction — pure, so the quoting rules are unit-testable.
//
// The download uses the SAME selection the chart shows (state.lastSeries), one
// column per series. Kept DOM-free here; main.ts wraps the result in a Blob.

export type Cell = string | number | null | undefined;

// RFC-4180 field quoting: wrap in quotes + double any embedded quote when the
// value holds a comma, quote or newline. Several dataset/level labels contain
// commas (e.g. "Monetary aggregates M1, M2 and M3"); unquoted they would split
// into extra columns and misalign every column to their right.
export function csvField(v: Cell): string {
  const s = v == null ? "" : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** header + rows -> CRLF-joined CSV text (no BOM — the caller adds it). */
export function toCsv(header: Cell[], rows: Cell[][]): string {
  return [header, ...rows].map(r => r.map(csvField).join(",")).join("\r\n");
}

/** UTF-8 BOM so Excel reads accented / en-dash labels correctly. */
export const CSV_BOM = "﻿";
